import mapboxgl from "mapbox-gl";
import { useEffect, useRef } from "react";

import { Wrapper } from "src/styled";
import { theme } from "src/styles";

interface Props {
  height: number;
  width?: number;
  locationPin?: {
    lat: number;
    lng: number;
  };
  center?: {
    lat: number;
    lng: number;
  };
  zoom?: number;
}

const MapDisplay = ({
  height,
  width,
  locationPin,
  zoom = 15,
  center = { lat: 44.967243, lng: -103.771556 },
}: Props) => {
  // const [map, setMap] = useState<any>(null);

  const mapContainer = useRef<any>(null);
  const map = useRef<mapboxgl.Map | null>(null);

  const mapCenter = locationPin || center;

  const marker = useRef<mapboxgl.Marker | null>(null);

  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      accessToken: process.env.REACT_APP_MAPBOX_API_KEY,
      container: mapContainer.current,
      style: process.env.REACT_APP_MAPBOX_MONOCHROME_THEME_URL,
      center: [mapCenter.lng, mapCenter.lat],
      zoom: zoom,
      attributionControl: false,
    });
  });
  // add location pin to map
  useEffect(() => {
    if (!map.current || !locationPin) return; // wait for map to initialize

    // clear all existing pins
    if (marker.current) marker.current.remove();

    marker.current = new mapboxgl.Marker({
      color: theme.brandPrimary,
      scale: 0.7,
    })
      .setLngLat([locationPin.lng, locationPin.lat])
      .addTo(map.current);

    map.current.flyTo({
      center: [locationPin.lng, locationPin.lat],
      zoom: zoom,
    });
  }, [locationPin, marker, zoom, map]);

  return <Wrapper height={height} width={width} ref={mapContainer} />;
};
export default MapDisplay;
